import React, { ReactNode } from "react"
import { useLocation } from "react-router-dom"
import { isUUID } from "utilities/strings"
import ErrorBoundary from "./ErrorBoundary"

// "/events/<uuid>/guests/<uuid>/edit" -> "/events/:id/guests/:id/edit", so
// Sentry groups the `boundary` tag by route instead of by record.
export const routeName = (pathname: string) => pathname
  .split("/")
  .map((segment) => (isUUID(segment) || /^\d+$/.test(segment) ? ":id" : segment))
  .join("/")

// Page-level boundary for everything rendered next to the app navigation.
// Placed once around the page routes, so every page and event tab, including
// ones added later, gets it without a wrapper of its own. It resets on
// navigation, so one instance serves all of them.
const RouteErrorBoundary = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation()

  return (
    <ErrorBoundary name={routeName(pathname)} variant="page">
      {children}
    </ErrorBoundary>
  )
}

export default RouteErrorBoundary
